import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import {
  SearchEventsByParams,
  getAttendees,
} from "../../../services/EventsService";
import { useAxiosInstance } from "../../../services/Interceptor";
import AthleteScore from "../../../components/athlete-scores/athlete-score";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";
import { useResponsiveHeight } from "../../../hooks/useResponsiveHeight";
import CoachCombineResultsSection from "./CoachCombineResultsSection";
import CoachCombineAthletesList from "./CoachCombineAthletesList";

function UniversityCombine() {
  const apiInstance = useAxiosInstance();
  const [athletes, setAthletes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [combines, setCombines] = useState([]);
  const [selectedCombineId, setSelectedCombineId] = useState(null);
  const [selectedAthlete, setSelectedAthlete] = useState(null);
  const authUser = useAuthUser();
  const { user = {} } = authUser;

  // Dropdown state for custom combine dropdown
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dropdownSearch, setDropdownSearch] = useState("");

  const fetchCombines = async () => {
    setLoading(true);
    try {
      const response = await SearchEventsByParams(apiInstance, "");
      setCombines(response);
    } catch (error) {
      console.error("Error fetching combines:", error);
    } finally {
      setLoading(false);
    }
  };

  const { adjustedHeight } = useResponsiveHeight({
    mobileHeight: 340,
    desktopHeight: 480,
  });

  const fetchAthletes = async (eventId) => {
    setLoading(true);
    try {
      const attendees = await getAttendees(apiInstance, eventId);
      setAthletes(attendees);
    } catch (error) {
      console.error("Error fetching attendees:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCombines();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCombineChange = (combineId) => {
    setSelectedCombineId(combineId);
    setDropdownOpen(false);
    setDropdownSearch("");
    if (combineId) {
      fetchAthletes(combineId);
    } else {
      setAthletes([]);
    }
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleAthleteClick = (athlete) => {
    setSelectedAthlete(athlete);
  };

  const backButtonClickEvent = () => setSelectedAthlete(null);

  // Filter combines for dropdown search
  const filteredCombines = combines.filter(
    (combine) =>
      combine.name.toLowerCase().includes(dropdownSearch.toLowerCase()) ||
      combine.city.toLowerCase().includes(dropdownSearch.toLowerCase()) ||
      combine.date.toLowerCase().includes(dropdownSearch.toLowerCase()),
  );

  // Filter athletes for search input
  const filteredAthletes = athletes.filter(
    (a) =>
      `${a.name} ${a.lastname}`
        .toLowerCase()
        .includes(searchQuery.toLowerCase()) ||
      (a.position &&
        a.position.toLowerCase().includes(searchQuery.toLowerCase())),
  );

  // Find selected combine for display
  const selectedCombine = combines.find((c) => c.id === selectedCombineId);

  return (
    <>
      <div className="flex h-full">
        <div className="flex-grow sm:pb-20 xl:pb-0 lg:pb-0">
          <div className="p-4 h-full bg-gray-100">
            <div className="flex flex-col xl:flex-row lg:flex-row gap-4 h-full">
              <div className="w-full lg:w-2/5 xl:w-2/5">
                <div className="bg-white shadow-lg p-4 rounded-lg border-gray-300 h-full">
                  <CoachCombineResultsSection
                    loading={loading}
                    dropdownOpen={dropdownOpen}
                    setDropdownOpen={setDropdownOpen}
                    selectedCombine={selectedCombine}
                    dropdownSearch={dropdownSearch}
                    setDropdownSearch={setDropdownSearch}
                    filteredCombines={filteredCombines}
                    onCombineChange={handleCombineChange}
                  />
                  <CoachCombineAthletesList
                    loading={loading}
                    searchQuery={searchQuery}
                    onSearch={handleSearch}
                    filteredAthletes={filteredAthletes}
                    adjustedHeight={adjustedHeight}
                    onAthleteClick={handleAthleteClick}
                    userRole={user.role}
                  />
                </div>
              </div>

              {selectedAthlete && (
                <div className="w-full lg:w-3/5 xl:w-3/5">
                  <div className="athletes-list h-full event_details_mob md:relative xl:relative lg:relative  md:col-span-7 xl:col-span-7 xl:space-y-0 xl:bg-transparent  xl:border-gray-300 p-0  md:space-y-0 md:top-0 xl:top-0 lg:top-0">
                    <div className="text-blue-600 pt-6 px-6 md:visible xl:hidden lg:hidden sm:visible ">
                      <NavLink onClick={() => backButtonClickEvent(false)}>
                        <FontAwesomeIcon icon={faChevronLeft} /> Back
                      </NavLink>
                    </div>

                    {selectedAthlete ? (
                      <div className="overflow-x-scroll h-full mb-10">
                        <AthleteScore
                          userId={selectedAthlete.userId}
                          showOffers={true}
                          showTrackittScore={true}
                          showPositionScore={true}
                          searchEvent={false}
                          showProfile={true}
                          showRank={true}
                          showLikes={true}
                          eventId={selectedCombineId || undefined}
                        />
                      </div>
                    ) : (
                      <div className="flex items-center justify-center h-full">
                        <div className="w-full p-2 mt-5 flex flex-col items-center">
                          <img
                            alt="Select Athlete"
                            src="/select_row.svg"
                            className="object-cover h-20 ml-18 pb-3"
                          />
                          <p className="text-center text-[#8E8E93] text-1xl">
                            Please select an Athlete to view their Profile
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default UniversityCombine;
